import { useQuery } from '@apollo/client';
import { Device, useDeviceViewport } from '@se-admin/falcon';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { IBooking } from '../../common/types/apiSchema';
import { ErrorKey, ErrorType } from '../../common/utils/tracking/tracking.interfaces';
import { trackError } from '../../common/utils/tracking/trackingUtils';
import {
  BookingDetailsDates,
  BookingDetailsHeader,
  BookingDetailsHotelInformation,
  BookingDetailsImage,
  BookingDetailsOccupancy,
  BookingDetailsOptions,
  BookingDetailsTransactionInformation,
} from './BookingDetailsPage.components';
import {
  GET_BOOKING,
  IBookingDetailsQueryData,
  IBookingDetailsQueryVariables,
} from './BookingDetailsPage.queries';
import { BookingDetailsPageWrapper, BookingDetailsWrapper } from './BookingDetailsPage.styles';

const BookingDetailsPage: React.FunctionComponent<{}> = () => {
  const device: Device = useDeviceViewport();
  const isMobile: boolean = device === Device.mobile;
  const { bookingId = null } = useParams<{ bookingId: string }>();
  window.scrollTo(0, 0);

  if (!bookingId) {
    trackError(
      ErrorKey.BOOKING_DETAILS_LOAD,
      ErrorType.LOADING_ERROR,
      'No booking ID given for booking details page'
    );
  }

  const { loading, error, data } = useQuery<
    IBookingDetailsQueryData,
    IBookingDetailsQueryVariables
  >(GET_BOOKING, {
    context: { protectedFlashsales: true },
    variables: { bookingId },
  });

  if (error) {
    trackError(ErrorKey.BOOKING_DETAILS_LOAD, ErrorType.LOADING_ERROR, error.message, error);
  }

  const booking: IBooking = !loading ? data.booking : null;

  return (
    <div>
      {booking && (
        <BookingDetailsPageWrapper>
          {isMobile && <BookingDetailsImage leadImage={booking.leadImage} />}
          <BookingDetailsWrapper>
            <BookingDetailsHeader booking={booking} />
            <BookingDetailsOccupancy booking={booking} />
            <BookingDetailsDates booking={booking} />
          </BookingDetailsWrapper>
          <BookingDetailsWrapper>
            {!isMobile && <BookingDetailsImage leadImage={booking.leadImage} />}
            <BookingDetailsTransactionInformation booking={booking} />
            <BookingDetailsHotelInformation booking={booking} />
            <BookingDetailsOptions booking={booking} />
          </BookingDetailsWrapper>
        </BookingDetailsPageWrapper>
      )}
    </div>
  );
};

export default BookingDetailsPage;
